import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { cleanSearchingRegionsPaginated, regionClean } from "../../app/actions/catalogRegionActions";

import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import DisplayNameAndRole from "./DisplayNameAndRole";

const ID_FORM = "admin-region";
const OPERATION_LIST = "list";

const NavbarIconsRegions = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewRegions", event: "NewRegions-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListRegions", event: "ListRegions-Clicked" });
       dispatch(cleanSearchingRegionsPaginated());
    }

    dispatch(regionClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listRegions" && (
        <Link
          data-tip
          data-for="newRegionsTip"
          to="/admin-region/new-region"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newRegions" && (
        <Link
          data-tip
          data-for="listRegionsTip"
          to="/admin-region/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editRegions" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listRegionsTip"
            to="/admin-region/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newRegionsTip"
            to="/admin-region/new-region"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newRegionsTip" place="left" effect="solid">
        {t("admin-region.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listRegionsTip" place="left" effect="solid">
        {t(`${ID_FORM}.page.${OPERATION_LIST}`)}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsRegions;
